module.exports = __webpack_public_path__ + "img/IMG_2254_L_WoodMatted_MockedUp.d921a986.jpg";